import React, { ReactElement } from 'react'
import { Stack, Text } from '@mindfulchefuk/design-system'

type TRecipeStep = {
  steps: string
}

export const RecipeBulletpointSteps = ({
  steps,
}: TRecipeStep): ReactElement => {
  return (
    <Stack
      as="ul"
      listStyleType="disc"
      spacing={6}
      ml={20}
      mb={32}
      data-testid="recipe-instructions"
    >
      {steps.split('\n').map((bulletPoint) => (
        <Text
          variant="body-lg"
          as="li"
          pl={4}
          key={bulletPoint}
          data-testid="recipe-bulletpoint"
        >
          {bulletPoint}
        </Text>
      ))}
    </Stack>
  )
}
